import React from 'react';
import CouponForm from './CouponForm';
import styles from './NewCoupon.module.sass';

const NewCoupon = () => {
  return (
    <div className={styles.row}>
        <div className={styles.col}>
          <CouponForm className={styles.card} />
          </div></div>
  )
}

export default NewCoupon